import { gql } from '@apollo/client'

export const GET_BEST_PRACTICE_CLASHES = gql`
    query GetBestPracticeClashes(
        $input: GetBestPracticeClashesInput!
    ) {
        bestPracticeClashes(input: $input) {
            id
            projectId
            bestPracticeId
            familyNumber
            productFamilyId
            productFamilyName
            errorMessage
            isResolved
            resolvedDate
            resolvedBy
            projectElementNodeId
            treePath
            contentTextPreview
            metadata {
                created
            }
        }
    }
`

export const GET_CLASH_COUNT = gql`
    query GetClashCount($input: GetBestPracticeClashCountInput!) {
        bestPracticeClashCount(input: $input)
    }
`
